<script lang="ts" setup>
import CatalogContent from "~/components/catalogs/CatalogContent.vue";

const route = useRoute();
const state = route.params.state.toLowerCase();
</script>

<template>
    <CatalogContent :state="state" />
</template>

<style scoped></style>
